import React from "react";
import { DefaultAndAuthProps } from "model/props";
import OrganisationScreen from "./OrganisationScreen";
import AddOrganisationScreen from "./AddOrganisationScreen";

/**
 * Wrapper component that decides which organisation screen to show:
 * - Super admins: see OrganisationScreen (list view with ability to add/edit multiple orgs)
 * - Other admins: see AddOrganisationScreen (edit their own organisation from props)
 */
const OrganisationWrapper: React.FC<DefaultAndAuthProps> = (props) => {
  const { admin } = props;

  // Super admin sees the list/table view
  if (admin?.is_super_admin) {
    return <OrganisationScreen {...props} />;
  }

  // Other admins see the edit screen for their organisation
  return <AddOrganisationScreen {...props} />;
};

export default OrganisationWrapper;
